import {z} from 'zod'

import {EngagementRowSchema} from './common'

export const CapacityEngagementMatrixDataSchema = z
    .object({
        rows: z.array(EngagementRowSchema),
        grand_total: z.number(),
    })
    .transform(({rows, grand_total}) => ({
        rows,
        grandTotal: grand_total,
    }))

export type CapacityEngagementMatrixData = z.infer<typeof CapacityEngagementMatrixDataSchema>
